import React, {Component} from 'react';
import {connect} from 'react-redux';
import './SmartForm.scss';
import {
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Form,
  FormText,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  Collapse,
  Alert
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import CustomDateTimeInput from './CustomDateTimeInput';
import FormFeedback from './FormFeedback';

class SmartForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapse: {}
    }

    this.editAble = typeof this.props.form.editAble !== 'undefined' ? this.props.form.editAble : true;

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentWillUpdate() {
    if ( this.props.alert.message != this.state.currentMessage && !this.state.alertOpen ) {
      this.setState({
        alertOpen: true,
        currentMessage: this.props.alert.message
      });
    }
  }

  setFormValue(field, value) {
    this.props.onSetFormValue(field, value);
  }

  toggle(element) {
    let id = element.id;
    this.setState({
      collapse: {
        ...this.state.collapse,
        [id]: !this.state.collapse[id]
      }
    });
  }

  renderElement(element) {
    let result;
    switch (element.type) {
      case "select":
        result = this.renderSelectInput(element);
        break;
      case "currency":
        result = this.renderCurrencyInput(element);
        break;
      case "password":
        result = this.renderPasswordInput(element);
        break;
      case "text":
        result = this.renderTextInput(element);
        break;
      case "datetime":
        result = this.renderDateTimeInput(element);
        break;
    }
    return result;
  }

  renderElements(elements) {
    let colWidth = Math.floor(12 / this.props.columns);
    let inputs = [];
    return (
      <Row>
        {
          elements.map((element, index) => {
            if ( element.type === 'group' ) {
              return <Col key={index} xs="12" md="12">{this.renderGroup(element)}</Col>
            } else {
              return <Col key={index} xs="12" md={colWidth}>{this.renderElement(element)}</Col>
            }
          })
        }
      </Row>
    )


  }

  renderGroup(element) {
    return (
      <div key={element.id} className="field-group">
        <div color="primary" className="field-group-button" onClick={() => {this.toggle(element)}} style={{ marginBottom: '1rem' }}>{element.text}</div>
        <Collapse className="field-group-collapse" isOpen={typeof this.state.collapse[element.id] == "undefined" ? true : !this.state.collapse[element.id]}>
          {this.renderElements(element.fields)}
        </Collapse>
      </div>
    )
  }

  renderCurrencyInput(field) {
    return (
      <FormGroup row key={field.id}>
        <Label md="4">{field.text}</Label>
        <Col xs="12" md="8">
          <InputGroup>
            <InputGroupAddon>
              $
            </InputGroupAddon>
            <Input
              type="text"
              name={field.id}
              value={this.props.formValues[field.id]}
              placeholder={field.text}
              valid={this.props.formErrors[field.id] && this.props.formErrors[field.id].length > 0 ? false : null}
              invalid={this.props.formErrors[field.id] && this.props.formErrors[field.id].length > 0 ? true : null}
              disabled={this.editAble && !field.disabled ? null : true}
              onChange={(e) => { this.setFormValue(field.id, e.target.value) }}/>
          </InputGroup>
          <FormText color="muted">
            {field.info}
          </FormText>
          <FormFeedback errors={this.props.formErrors[field.id]} />
        </Col>
      </FormGroup>
    );
  }

  renderSelectInput(field) {
    return (
      <FormGroup row key={field.id}>
        <Label md="4">{field.text}</Label>
        <Col xs="12" md="8">
          <Input
            type="select"
            name={field.id}
            value={this.props.formValues[field.id]}
            placeholder={field.text}
            valid={this.props.formErrors[field.id] && this.props.formErrors[field.id].length > 0 ? false : null}
            invalid={this.props.formErrors[field.id] && this.props.formErrors[field.id].length > 0 ? true : null}
            disabled={this.editAble && !field.disabled ? null : true}
            onChange={(e) => { this.setFormValue(field.id, e.target.value) }}>
            <option value="">Please select</option>
            {field.options.map((option, index) => {
              return (
                <option key={index} value={option.value}>{option.text}</option>
              )
            })}
          </Input>
          <FormText color="muted">
            {field.info}
          </FormText>
          <FormFeedback errors={this.props.formErrors[field.id]} />
        </Col>
      </FormGroup>
    );
  }

  renderDateTimeInput(field) {
    return (
      <FormGroup row key={field.id}>
        <Label md="4">{field.text}</Label>
        <Col xs="12" md="8">
          <DatePicker
            className={`form-control btn-block btn-secondary`}
            customInput={<CustomDateTimeInput/>}
            selected={this.props.formValues[field.id]}
            onChange={(date) => { this.setFormValue(field.id, date) }}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={1}
            dateFormat="LLL"
            timeCaption="time"
            disabled={this.editAble && !field.disabled ? null : true}
          />
          <FormText color="muted">
            {field.info}
          </FormText>
          <FormFeedback errors={this.props.formErrors[field.id]} />
        </Col>
        <Col md="4">
        </Col>
      </FormGroup>
    );
  }

  renderCheckBoxInput(field) {
    return (
      <FormGroup row key={field.id}>
        <Col md="4">
        </Col>
        <Col xs="12" md="8">
          <Label check>
            <Input
              type="checkbox"
              name={field.id}
              value={this.props.formValues[field.id]}
              checked={this.props.formValues[field.id]}
              onChange={(e) => { this.setFormValue(field.id, e.target.value) }}/>
            <FormText color="muted">
              {field.info}
            </FormText>
            <FormFeedback errors={this.props.formErrors[field.id]} />
          </Label>
        </Col>
      </FormGroup>
    );
  }

  renderPasswordInput(field) {
    return (
      <FormGroup row key={field.id}>
        <Label md="4">{field.text}</Label>
        <Col xs="12" md="8">
          <Input
            type="password"
            name={field.id}
            value={this.props.formValues[field.id]}
            placeholder={field.text}
            valid={this.props.formErrors[field.id] && this.props.formErrors[field.id].length > 0 ? false : null}
            invalid={this.props.formErrors[field.id] && this.props.formErrors[field.id].length > 0 ? true : null}
            disabled={this.editAble && !field.disabled ? null : true}
            onChange={(e) => { this.setFormValue(field.id, e.target.value) }}/>
          <FormText color="muted">
            {field.info}
          </FormText>
          <FormFeedback errors={this.props.formErrors[field.id]} />
        </Col>
      </FormGroup>
    );
  }

  renderTextInput(field) {
    return (
      <FormGroup row key={field.id}>
        <Label md="4">{field.text}</Label>
        <Col xs="12" md="8">
          <Input
            type="text"
            name={field.id}
            value={this.props.formValues[field.id]}
            placeholder={field.text}
            valid={this.props.formErrors[field.id] && this.props.formErrors[field.id].length > 0 ? false : null}
            invalid={this.props.formErrors[field.id] && this.props.formErrors[field.id].length > 0 ? true : null}
            disabled={this.editAble && !field.disabled ? null : true}
            onChange={(e) => { this.setFormValue(field.id, e.target.value) }}/>
          <FormText color="muted">
            {field.info}
          </FormText>
          <FormFeedback errors={this.props.formErrors[field.id]} />
        </Col>
      </FormGroup>
    );
  }

  renderFormFooter() {
    if ( this.editAble ) {
      if ( this.props.footer ) {
        return (
          <CardFooter>
            {this.renderButtons()}
          </CardFooter>
        );
      }
    }
  }

  renderFormButtons() {
    if ( !this.props.footer ) {
      return this.renderButtons();
    }
  }

  renderButtons() {
    if ( this.props.buttons.length > 0 ) {
      return (
        <div className="btn-toolbar">
          {this.props.buttons.map((button, index) => { return (<div key={index} className="btn-group">{button}</div>) })}
        </div>
      );
    } else {
      return (
        <div>
          <Button size="sm" color="success" onClick={this.props.onSubmit}><i className="fa fa-floppy-o"></i> Save</Button>
        </div>
      );
    }
  }

  handleFormSubmit(e) {
    e.preventDefault();
    this.props.onSubmit();
  }

  renderForm() {
    return (
      <Card className="SurveyForm">
        <CardBody>
            <Alert color={this.props.alert.color} isOpen={this.props.alert.message != ""} toggle={() => this.props.onAlertDismiss()}>
              {this.props.alert.message}
            </Alert>
          <Form onSubmit={this.handleFormSubmit} encType="multipart/form-data" className="form-horizontal">
            <div className="animated fadeIn">
              {this.renderElements(this.props.form.fields)}
            </div>
            {this.renderFormButtons()}
          </Form>
        </CardBody>
        {this.renderFormFooter()}
      </Card>
    );
  }

  render() {
    return this.renderForm();
  }
}

SmartForm.defaultProps = {
  buttons: [],
  onSubmit: () => {},
  onSetFormValue: () => {},
  onAlertDismiss: () => {},
  columns: 1,
  formValues: {},
  formErrors: {},
  form: {
    fields: [],
    editAble: true
  },
  alert: {
    color: "success",
    message: ""
  },
  footer: true
};

export default SmartForm;



// WEBPACK FOOTER //
// ./src/components/SmartForm/SmartForm.js